export enum SplitPaymentState {
    False = 'False',
    True = 'True',
    Manual = 'Manual'
}
